<script setup lang="ts">
const props = defineProps({
  unit: {
    type: String,
    required: false,
  },
});

const emit = defineEmits(["showUnit"]);

const units = ref<any[]>([]);

onMounted(async () => {
  const response = await $fetch(`/api/thesaurus/structure`, {
    headers: await useApiHeaders(),
  });
  units.value = response;
});

const matchingUnit = computed(() => {
  return units.value.find((u: any) => u.unit == props.unit);
});

const openUnitModel = () => {
  if (matchingUnit.value == undefined) return;

  emit("showUnit", matchingUnit.value);
};
</script>

<template>
  <span
    class="text-warning"
    :class="{
      'underline cursor-pointer hover:text-primary-default':
        matchingUnit != undefined,
    }"
    @click="openUnitModel"
  >
    Unit {{ unit }}
  </span>
</template>

<style scoped></style>
